import * as React from 'react';
import { By83, Footer, Wordmark } from '../app/Brand';
import { signIn } from '../auth';
import { ENVIRONMENT_LABEL } from '../config';
import { PRODUCT_NAME } from '../app/product';

function MicrosoftLogo(): React.ReactElement {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" aria-hidden="true">
      <rect x="1" y="1" width="8.5" height="8.5" fill="#f25022" /><rect x="10.5" y="1" width="8.5" height="8.5" fill="#7fba00" />
      <rect x="1" y="10.5" width="8.5" height="8.5" fill="#00a4ef" /><rect x="10.5" y="10.5" width="8.5" height="8.5" fill="#ffb900" />
    </svg>
  );
}

export default function SignIn(): React.ReactElement {
  return (
    <div className="signin">
      <header className="signin-top">
        <div className="brand">
          <Wordmark size={28} />
          {ENVIRONMENT_LABEL && <span className="env-badge">{ENVIRONMENT_LABEL}</span>}
          <By83 />
        </div>
        <a href="/support" style={{ fontSize: 15 }}>Help</a>
      </header>
      <main className="signin-main">
        <div className="signin-grid">
          <section>
            <span className="eyebrow">For immigration law firms</span>
            <h1>Every immigration file, on track.</h1>
            <p className="lead" style={{ maxWidth: 520 }}>Checklists for each person, documents from clients, IRCC letters and the dates that follow, all kept in your firm's own Microsoft 365.</p>
            <div style={{ display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap' }}>
              <button type="button" className="ms-btn" onClick={() => { void signIn(); }}><MicrosoftLogo />Sign in with Microsoft 365</button>
              <span className="muted" style={{ fontSize: 15 }}>Your first 5 applications are free.</span>
            </div>
            <p className="small" style={{ margin: 0, fontSize: 14 }}>Signing in takes you to Microsoft and back to this page. No popups.</p>
            <div className="promises">
              <div><strong>Your files stay put</strong>Records and documents live in your SharePoint. We keep no copies.</div>
              <div><strong>Nothing is deleted</strong>Every change is in History and can be undone.</div>
              <div><strong>Your team decides</strong>Dates are calculated for you to check. Nothing is sent to IRCC.</div>
            </div>
          </section>
          <section className="sample" aria-label="A sample file">
            <div className="spread" style={{ alignItems: 'flex-start' }}>
              <div className="stack">
                <span className="small">Spousal sponsorship · outside Canada</span>
                <strong style={{ fontSize: 18 }}>Khalil, Omar</strong>
              </div>
              <span className="mono small">26-0114</span>
            </div>
            <div className="stack" style={{ gap: 6 }}>
              <div className="spread" style={{ fontSize: 14 }}><span>Collecting documents</span><span className="muted">14 of 22 received</span></div>
              <div className="bar" style={{ height: 8 }}><span style={{ width: '64%' }} /></div>
            </div>
            <div>
              <div className="line"><span>Passport · Omar</span><span className="muted" style={{ fontSize: 13 }}>Received</span></div>
              <div className="line"><span>Police certificate · Omar</span><span className="muted" style={{ fontSize: 13 }}>Requested</span></div>
              <div className="line"><span>Proof of relationship</span><span className="muted" style={{ fontSize: 13 }}>Requested</span></div>
              <div className="line"><span>Sponsor's notice of assessment</span><span className="muted" style={{ fontSize: 13 }}>Received</span></div>
            </div>
            <div className="check-note">
              <strong style={{ fontSize: 14 }}>Biometrics · Nov 2</strong>
              <span>Calculated from the letter. Please check.</span>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}
